import * as React from 'react';

import styled, { css } from 'styled-components';

import { AnimatePresence } from 'framer-motion';

import Typography from '@components/basics/typography';
import UnselectedIcon from '@components/basics/icons/unselected';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';

export interface SidebarItemContentProps {
  className?: string;
  text: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  done?: boolean;
  noIcon?: boolean;
  error?: boolean;
}

export const SidebarItemContent: React.FC<SidebarItemContentProps> = (
  props
) => (
  <div className={props.className}>
    <AnimatePresence exitBeforeEnter>
      {props.noIcon ? null : props.done && !props.error ? (
        <CompletedIcon className="icon" />
      ) : (
        <UnselectedIcon
          noLine
          className="icon"
          active={props.active}
          error={props.error}
        />
      )}
    </AnimatePresence>
    <Typography className="text" weight="700">
      {props.text}
    </Typography>
  </div>
);

export default styled(SidebarItemContent)`
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .icon {
    width: 24px;
    height: 24px;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  ${(props) =>
    props.done
      ? css`
          .check {
            opacity: 1;
          }
          .unselected {
            opacity: 0;
          }
        `
      : css`
          .check {
            opacity: 0;
          }
          .unselected {
            opacity: 1;
          }
        `}

  ${(props) =>
    !props.active
      ? css`
          &:hover {
            .text {
              color: ${({ theme }) => theme.colors.primary};
            }
          }
          .text {
            color: ${({ theme }) => theme.colors.tertiary};
            transition: color
              ${({ theme }) =>
                `${theme.transitions.duration} ${theme.transitions.type}`};
          }
        `
      : null}

  ${(props) =>
    props.active && props.disabled
      ? css`
          .text {
            color: ${({ theme }) => theme.colors.primary};
          }
        `
      : null}
  ${(props) =>
    props.disabled
      ? css`
          opacity: 0.5;
        `
      : null}
`;
